import React from 'react'
import { Modal } from 'react-responsive-modal'
import { CriteriaItemType } from '../../containers/ProfileContestsPage/types'

// Styles
import './styles.scss'
import 'react-responsive-modal/styles.css'

// Images
import ImageHeader from './images/imageHeader'

const modalStyles = {
  root: {
    zIndex: 99999,
  },
  overlay: {
    background: 'rgba(0, 0, 0, 0.4)',
  },
  modal: {
    width: 1185,
    maxWidth: 1185,
    borderRadius: 50,
    padding: 0,
    margin: '2em',
    boxShadow: 'unset',
    overflow: 'unset',
    outline: 0,
  },
}

export default ({
  modal,
  criteries,
  onClose,
}: {
  modal: boolean
  criteries: CriteriaItemType[]
  onClose: () => void
}) => {
  const percentFlex = 100 / (criteries.length + 1)
  const styleFlex = { flex: `0 0 ${percentFlex}%`, maxWidth: `${percentFlex}%` }

  const rows = [
    'Низкий балл от 1 до 5',
    'Средний балл от 6 до 7',
    'Высокий балл от 8 до 9',
    'Высший балл 10',
  ]

  return (
    <Modal
      open={modal}
      onClose={onClose}
      styles={modalStyles}
      showCloseIcon={false}
    >
      <div className={'modal-criteries'}>
        <div className={'modal-criteries__header'}>
          <div className={'modal-criteries__header-title'}>Критерии оценки</div>
          <div className={'image'}>
            <ImageHeader />
          </div>
        </div>
        <div className={'modal-criteries__main'}>
          <div className={'modal-criteries__main-row'}>
            <div style={styleFlex} className={'item'}>
              <div className={'item__outer global'}>Критерии оценки</div>
            </div>
            {criteries.map(item => (
              <div key={item.criterion_id} style={styleFlex} className={'item'}>
                <div className={'item__outer blue'}>{item.caption}</div>
              </div>
            ))}
          </div>
          {rows.map((row, index) => (
            <div key={`row-${index}`} className={'modal-criteries__main-row'}>
              <div className={'item'} style={styleFlex}>
                <div className={'item__outer light-green'}>{row}</div>
              </div>
              {criteries.map((item, indexDescription) => (
                <div
                  key={`row-${index}-${indexDescription}`}
                  className={'item'}
                  style={styleFlex}
                >
                  <div className={'item__outer'}>
                    {item.description.split('\n')[index]}
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </Modal>
  )
}
